import uuid from '../uuid';
import { getAnswersData } from './getAnswersData';

export const getCustomerUuid = function () {
  const params = new URLSearchParams(window.location.search);
  // This pattern covers only upsales, downsales and check for active products(edge cases)!
  let customerUuidPathnameMatch = new RegExp(`.+/(${uuid.pattern()})(/upsales|/downsale|/products|.+token)`).exec(
    window.location.pathname,
  );

  if (customerUuidPathnameMatch) {
    customerUuidPathnameMatch = customerUuidPathnameMatch[1];
  }

  return (
    customerUuidPathnameMatch ||
    params.get('cid') ||
    params.get('customerUuid') ||
    store.getCustomerUuid() ||
    getAnswersData('customer_uuid') ||
    backEndVars.customerUuid
  );
};
